// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'


// import LoadScript from 'vue-plugin-load-script';
// Vue.use(LoadScript);

Vue.config.productionTip = false

Vue.config.ignoredElements = [
  'ph-window', 'window-content', 'nav-group', 'nav-item', 'tool-bar',
]

Vue.prototype.$locations = ['RCGB', 'RMGB', 'WGB'];
Vue.prototype.$distributors = ['', 'JTI', 'Imperial', 'Rothmans'];
Vue.prototype.$_auid = localStorage._auid;
Vue.prototype.$isDev = localStorage.isDev === "true";
Vue.prototype.$voidHref = 'JavaScript:Void(0);'

import customAxios from '@/plugins/axios.js'
Vue.use(customAxios)
import mathAndNumeral from '@/plugins/math.js'
Vue.use(mathAndNumeral)
import util from '@/plugins/util.js'
Vue.use(util)
import atlApexCharts from '@/plugins/atlApexCharts.js'
Vue.use(atlApexCharts)
import atlTwilioSync from '@/plugins/atlTwilioSync.js'
Vue.use(atlTwilioSync)

import globalComponentRegistration from '@/plugins/globalComponentRegistration.js'
Vue.use(globalComponentRegistration)

import _ from 'lodash'
Vue.prototype.$_ = _;

Vue.prototype.$console = window.console;

// import vueDebounce from 'vue-debounce'
// Vue.use(vueDebounce);

/* eslint-disable no-new */

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')